import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import API_URL from "../config";
const Empctrlwork = () => {
  const [codenum, setCode] = useState("");
  const [resultats, setResultats] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null); // ✅ gestion d'erreur

  const handleChangtel = (e) => {
    setCode(e.target.value);
    fetchHistory();
  };

  // Fonction pour récupérer l'historique
  const fetchHistory = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.post(`${API_URL}/tresseuse_history/`, {
        codenum,
      });
      /*  const response = await axios.post(
        "http://localhost:8000/api/tresseuse_history/",
        { ltel: "" }, // tu peux mettre un filtre si nécessaire
        { withCredentials: true } // pour CSRF / sessions Django
      );  */

      setResultats(response.data.resultats);
    } catch (err) {
      console.error("Erreur :", err);
      setError("Impossible de charger l'historique");
    } finally {
      setLoading(false);
    }
  };

  // Appel automatique au montage du composant
  useEffect(() => {
    fetchHistory();
  }, []);

  /* const handleCheckout = async (idtres, nomtres) => {
    alert(`Checkout pour ${nomtres} (ID: ${idtres})`);
    // Ici tu peux appeler une API DRF pour enregistrer le checkout

    try {
      const response = await axios.put(
        `http://localhost:8000/api/update_histstatut/${idtres}/`
      );
      alert(response.data.message);
    } catch (error) {
      console.error("Erreur lors de la mise à jour :", error);
      alert("Échec de la mise à jour du statut");
    }
  };  */

  const handleCheckout = async (idtres, nomtres) => {
    if (!window.confirm(`Confirmer le checkout pour ${nomtres} ?`)) return;

    try {
      await axios.put(`${API_URL}/update_histstatut/${idtres}/`);

      // 🔹 Supprimer la ligne correspondante du tableau await axios.put(`${API_URL}/update_histstatut/${idtres}/`);
      setResultats((prev) => prev.filter((r) => r.idtres !== idtres));
      //fetchHistory();
      // 🔹 Message de confirmation
      alert(`Checkout réussi pour ${nomtres}`);
    } catch (error) {
      console.error("Erreur lors du checkout :", error);
      alert("Erreur lors de la mise à jour du statut !");
    }
  };

  // 2️⃣ useEffect pour recharger le tableau à chaque modification
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchHistory(); // fonction qui utilise la valeur actuelle de codenum
    }, 300); // 300ms de debounce pour limiter les appels API

    return () => clearTimeout(delayDebounceFn); // nettoyage si l'utilisateur tape vite
  }, [codenum]);

  return (
    <div style={styles.pageBackground}>
      {/* Bandeau défilant */}
      <div style={styles.marqueeContainer}>
        <marquee behavior="scroll" direction="left" scrollamount="6">
          <span style={styles.marqueeText}>
            🌸 WELCOME TO NADINE'S HAIR BRAIDING &nbsp; | &nbsp; Tel: (202)
            706-2506 &nbsp; | &nbsp; Address: 4501 Mitchellville Road, Bowie, MD
            20716 🌸
          </span>
        </marquee>
      </div>

      <div className="container-fluid py-1">
        <div className="row justify-content-center">
          <div className="col-11 col-md-11 col-lg-10">
            <div style={styles.card}>
              {/* Logo */}
              <div className="text-center mb-4">
                <img
                  src={require("../../assets/images/logo_fenasu.png")}
                  alt="logo"
                  style={{ width: "180px" }}
                />
                <h2>CHECKING CONTROL LIST</h2>
              </div>

              {/* Formulaire */}
              <form>
                <div className="row g-4 align-items-end mb-4">
                  <div className="col-md-7">
                    <label className="form-label fw-bold fs-5">Telephone</label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      placeholder="Recherche"
                      value={codenum}
                      onChange={(e) => setCode(e.target.value)}
                    />
                  </div>

                  <div className="col-md-4 justify-content-center">
                    {/* Bouton Refresh */}
                    <button
                      type="button"
                      className="btn fw-bold shadow-sm"
                      style={styles.viewButton}
                      onClick={fetchHistory}
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm "
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Chargement...
                        </>
                      ) : (
                        "🔍 Refresh"
                      )}
                    </button>

                    {/* Bouton Retour */}
                    <button
                      type="button"
                      className="btn fw-bold shadow-sm"
                      style={styles.backButton}
                      onClick={() => navigate(-1)}
                    >
                      ⬅ Back
                    </button>
                  </div>
                </div>

                {/* Tableau */}
                <div className="table-responsive mt-4">
                  {/* ✅ SPINNEUR central pendant chargement */}
                  {loading && (
                    <div className="text-center my-4">
                      <div
                        className="spinner-border text-primary"
                        style={{ width: "4rem", height: "4rem" }}
                        role="status"
                      ></div>
                      <p className="mt-3 fw-bold">Chargement des données...</p>
                    </div>
                  )}

                  {/* Message d’erreur */}
                  {error && <div className="alert alert-danger">{error}</div>}

                  {/* Tableau de résultats */}
                  <div className="table-responsive mt-4">
                    {!loading && resultats.length > 0 && (
                      <table
                        className="table table-hover text-center align-middle w-100"
                        style={{
                          fontSize: "1.3rem",
                          borderRadius: "10px",
                          overflow: "hidden",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                          minWidth: "600px", // largeur minimale si le contenu est large
                        }}
                      >
                        <thead
                          style={{
                            background:
                              "linear-gradient(90deg, #00c6ff 0%, #0072ff 100%)",
                            color: "white",
                            fontSize: "1.2rem",
                          }}
                        >
                          <tr>
                            <th>#</th>
                            <th>Code</th>
                            <th>Nom</th>
                            <th>Téléphone</th>
                            <th>Date-Heure</th>
                            <th>Duration</th>
                            <th>Checkout</th>
                          </tr>
                        </thead>
                        <tbody>
                          {resultats.map((r, i) => (
                            <tr
                              key={i}
                              style={{
                                backgroundColor: r.over16h
                                  ? "red"
                                  : "transparent",
                              }}
                            >
                              <td>{i + 1}</td>
                              <td>{r.codtres}</td>
                              <td>{r.nomtres}</td>
                              <td>{r.telephone}</td>
                              <td>{r.histTime}</td>
                              <td>{r.duration}</td>
                              <td>
                                <button
                                  type="button" // ⬅️ LIGNE CRUCIALE
                                  className="btn btn-success btn-sm"
                                  onClick={() =>
                                    handleCheckout(r.idtres, r.nomtres)
                                  }
                                >
                                  Checkout
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* 🎨 Styles */
const styles = {
  backButton: {
    background: "linear-gradient(90deg, #ff512f 0%, #dd2476 100%)",
    color: "white",
    border: "none",
    fontSize: "1.1rem",
    borderRadius: "10px",
    width: "100%",
    maxWidth: "120px",
    height: "45px",
  },
  pageBackground: {
    minHeight: "100vh",
    background: "linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%)",
  },
  marqueeContainer: {
    background: "linear-gradient(90deg, #6a11cb 0%, #2575fc 100%)",
    padding: "12px 0",
    borderBottom: "3px solid #fff",
  },
  marqueeText: {
    color: "#fff",
    fontWeight: "bold",
    fontSize: "1.3rem",
    letterSpacing: "1px",
  },
  card: {
    background: "#fff",
    borderRadius: "15px",
    padding: "50px 40px",
    minHeight: "85vh",
    boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
    transition: "all 0.3s ease-in-out",
  },
  viewButton: {
    background: "linear-gradient(90deg, #00c6ff 0%, #0072ff 100%)",
    color: "white",
    border: "none",
    fontSize: "1.2rem",
    borderRadius: "10px",
    width: "160px",
    height: "50px",
    transition: "0.3s",
  },
  table: {
    fontSize: "1.2rem",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
  },
  tableHead: {
    background: "linear-gradient(90deg, #00c6ff 0%, #0072ff 100%)",
    color: "white",
    fontSize: "1.4rem",
  },
};

export default Empctrlwork;
